SNIPPETS

<template>
    <div 
        :id="'five-point-rating-' + id"
        class="d-flex justify-content-start align-items-center"
    >
        <b-form-radio-group
            :checked="scoreLocal"
            @change="handleScoreSelection"
            :options="options"
            buttons
            button-variant="outline-input"
            size="sm"
            class="spl-five-point-rating"
            :class="'score-' + scoreString"
        >
        </b-form-radio-group>
        <b-form-checkbox
            v-if="!disableNoScore"
            button
            :checked="noScore"
            button-variant="outline-input"
            size="sm"
            class="ml-2"
            @change="handleNoScoreSelection"
        >
            N/A
        </b-form-checkbox>
        <b-button
            v-if="isSet"
            variant="bare-secondary"
            size="sm"
            @click="resetValue"
        >
            <b-icon icon="x"></b-icon>
        </b-button>
    </div>
</template>

<script>
import uniqueId from 'lodash/uniqueId';

export default {
    name: 'BaseRatingFivePoint',
    components: {},
    props: {
        score: {
            type: Number,
            default: null,
        },
        noScore: {  // set to TRUE if specifically selected N/A, etc.  this takes priority over score value
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: function() {  // this works nicely... gotta make sure to put lodash uniqueId inside a function
                return uniqueId();
            },
        },
        locked: {  // if true, cannot edit, display only
            type: Boolean,
            default: false,
        },
        disableNoScore: {  // if true, it hides 'N/A' as an option
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            options: [
                { text: 'Poor', value: 1, },
                { text: 'Below Avg', value: 2, },
                { text: 'Average', value: 3, },
                { text: 'Good', value: 4, },
                { text: 'Excellent', value: 5, },
            ],
        }
    },
    computed: {
        scoreLocal: function() {
            if (this.noScore) {
                return null;
            }
            return this.score; // no need to check if we have it and set to null otherwise if we have default value of null set on prop
        },
        noScoreLocal: function() {
            return this.noScore;  // no need to check if we have it set and set false otherwise, as long as we have default value of false on prop
        },
        isSet: function() {
            // boolean for whether it has a value set 
            return (this.score != null) || (this.noScore);
        },
        scoreString: function() { // used to generate class name for button group based on current score, so you can change button colors in CSS, etc.
            return (this.scoreLocal != null) ? this.scoreLocal.toString() : 'empty';
        },
    },
    methods: {
        emitScore: function(scoreValue, noScoreBoolean) {
            // emit multiple things related to score (score, noScore, etc.)
            // WARNING... USE @CHANGE EVENTS ON INPUTS THAT CALL THIS, OTHERWISE IT WILL GET CALLED MULTIPLE TIMES IF YOU USE @INPUT EVENTS
            // @CHANGE EVENTS PREVENT THAT, ONLY CALLING THE EVENT WHICH IS CHANGED BY USER
            this.$emit('score-update', scoreValue);
            this.$emit('no-score-update', noScoreBoolean);
        },
        resetValue: function() {
            // reset all things... doing this will likely make score invalid on parent, but that's whats intended I think
            this.emitScore(null, false);
        },
        handleScoreSelection: function(scoreValue) {
            // if a score is selected, that means N/A should be unselected and score selected
            // no need to set local data... just emit events and let parent circle back with updated values
            this.emitScore(scoreValue, false);
        },
        handleNoScoreSelection: function() {
            // assume that ANY click on N/A button means N/A should be selected and score should be set to null
            this.emitScore(null, true);
        },
    }
}
</script>

<style>
.spl-five-point-rating.btn-group .btn {
    min-width: 80px;
}
.spl-five-point-rating.btn-group.score-1 .btn.active {
    background-color: var(--danger-200) !important;
}
.spl-five-point-rating.btn-group.score-2 .btn.active {
    background-color: var(--danger-100) !important;
}
.spl-five-point-rating.btn-group.score-3 .btn.active {
    background-color: var(--warning-100) !important;
}
.spl-five-point-rating.btn-group.score-4 .btn.active {
    background-color: var(--success-100) !important;
}
.spl-five-point-rating.btn-group.score-5 .btn.active {
    background-color: var(--success-200) !important;
}

</style>